export default "__VITE_ASSET__Tqcm4ICH__"